import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "auth-brand__logo-wrap" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "auth-brand__title" }
const _hoisted_4 = {
  key: 0,
  class: "auth-brand__subtitle"
}

import { computed, useAttrs } from "vue";

type AuthBrandData = {
  logo: string;
  title: string;
  subtitle?: string;
};


export default /*@__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'AppAuthBrand',
  props: {
    data: {},
    logoAlt: { default: "ServeNow" },
    titleColor: {},
    subtitleColor: {},
    subtitleSize: {},
    gap: { default: "0px" },
    marginTop: { default: "52px" },
    logoSpacing: { default: "8px" }
  },
  setup(__props: any) {



const props = __props;

const attrs = useAttrs();

const brandClass = computed(() => ["auth-brand", attrs.class]);

const brandStyle = computed(() => ({
  "--auth-brand-gap": props.gap,
  "--auth-brand-margin-top": props.marginTop,
  "--auth-title-color": props.titleColor || undefined,
  "--auth-subtitle-color": props.subtitleColor || undefined,
  "--auth-subtitle-size": props.subtitleSize || undefined,
  "--auth-logo-spacing": props.logoSpacing || undefined,
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(brandClass.value),
    style: _normalizeStyle(brandStyle.value)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: __props.data.logo,
        alt: __props.logoAlt,
        class: "auth-brand__logo"
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("h3", _hoisted_3, _toDisplayString(__props.data.title), 1),
    (__props.data.subtitle)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(__props.data.subtitle), 1))
      : _createCommentVNode("", true)
  ], 6))
}
}

})